import { Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { mergeRequestSummaryTemplates } from '../../helpers/request-summary-column/request-summary-column.helper';

/** Swaps the ID / workflow type / subject cell templates for the combined Request cell. */
@Pipe({
  name: 'requestSummaryTemplates',
  standalone: true,
})
export class RequestSummaryTemplatesPipe implements PipeTransform {
  transform<T extends { identifier?: string; template: TemplateRef<unknown> }>(
    value: T[] | null | undefined,
    enabled: boolean,
    summaryTemplate: TemplateRef<unknown>
  ): T[] {
    return mergeRequestSummaryTemplates(value ?? [], enabled, summaryTemplate);
  }
}
